/* Keep price truth server-rendered; storage holds only shopper-selected presentation preferences. */
(function (root) {
  'use strict';
  function aggregate(lines, id) {
    return lines.filter(line => String(line.id) === String(id) && !line.subscription)
      .reduce((sum, line) => ({ quantity: sum.quantity + line.quantity, original: sum.original + line.original, net: sum.net + line.net }), { quantity: 0, original: 0, net: 0 });
  }
  function matching(items, species, kind) {
    return items.filter(item => (species === 'all' || item.species === species) && (kind === 'all' || item.kind === kind));
  }
  if (typeof module === 'object' && module.exports) module.exports = { aggregate, matching };
  if (!root.document) return;
  const money = value => Math.round(value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
  function track(event, details) {
    if (!root.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    (root.dataLayer ||= []).push({ event, release: 'value-refresh-20260929', ...details });
  }
  function storage(action, key, value) {
    try { return action === 'get' ? sessionStorage.getItem(key) : sessionStorage.setItem(key, value); } catch (_) { return null; }
  }
  let priceVersion = 0;
  async function refreshPrices() {
    const version = ++priceVersion;
    const nodes = document.querySelectorAll('[data-dv-value-price]');
    if (!nodes.length) return;
    // Remove stale discount claims immediately; base price remains usable if refresh fails.
    nodes.forEach(node => node.querySelectorAll('.dv-value-price__label,.dv-value-price__cart').forEach(part => { part.hidden = true; }));
    try {
      const url = new URL(root.Shopify?.routes?.root || '/', location.origin);
      url.searchParams.set('section_id', 'dv-cart-prices');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = html.querySelector('[data-dv-price-state]');
      if (!state || version !== priceVersion) return;
      const lines = JSON.parse(state.textContent);
      document.querySelectorAll('[data-dv-value-price]').forEach(node => {
        const value = aggregate(lines, node.dataset.dvValuePrice);
        const note = node.querySelector('.dv-value-price__cart');
        const label = node.querySelector('.dv-value-price__label');
        if (!note || !label) return;
        const discounted = value.quantity > 0 && value.net < value.original;
        if (discounted) note.textContent = `${value.quantity} stk. í körfu: ${money(value.net)} eftir afslátt`;
        note.hidden = label.hidden = !discounted;
      });
    } catch (_) { /* A missing quote must not prevent normal purchasing. */ }
  }
  function enhance(scope = document) {
    const previousPack = storage('get', 'dv:last-pack');
    scope.querySelectorAll('a.dv-conversion-pack').forEach(link => {
      if (new URL(link.href).pathname !== previousPack || link.querySelector('[data-dv-last-pack]')) return;
      const hint = document.createElement('small');
      hint.dataset.dvLastPack = 'true';
      hint.textContent = 'Síðast skoðað';
      link.append(hint);
    });
    if (document.querySelector('.dv-conversion-pack.is-current')) storage('set', 'dv:last-pack', location.pathname);
    scope.querySelectorAll('[data-dv-discovery]:not([data-value-ready])').forEach(host => {
      host.dataset.valueReady = 'true';
      const controls = host.querySelector('[data-dv-discovery-controls]');
      const buttons = [...host.querySelectorAll('[data-dv-species]')];
      const rows = [...host.querySelectorAll('[data-dv-discovery-item]')];
      const select = host.querySelector('[data-dv-food-kind]');
      let species = storage('get', 'dv:species') || 'all';
      if (!buttons.some(button => button.dataset.dvSpecies === species)) species = 'all';
      function show(userAction = false) {
        const candidates = matching(rows.map(row => ({ species: row.dataset.species, kind: row.dataset.kind, row })), species, select.value);
        rows.forEach(row => { row.hidden = !candidates.some(item => item.row === row); });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dvSpecies === species)));
        host.querySelector('[data-dv-discovery-status]').textContent = candidates.length ? `${candidates.length} ${candidates.length === 1 ? 'vara' : 'vörur'} í þessu úrvali. Skoðaðu allan vöruflokkinn fyrir fleiri valkosti.` : 'Engin vara í þessu litla úrvali passar við valið. Skoðaðu allan vöruflokkinn hér fyrir neðan.';
        if (userAction) track('dv_discovery_selection', { species, kind: select.value });
      }
      buttons.forEach(button => button.addEventListener('click', () => { species = button.dataset.dvSpecies; storage('set', 'dv:species', species); show(true); }));
      select.addEventListener('change', () => show(true));
      controls.hidden = false;
      show();
    });
    scope.querySelectorAll('[data-dv-purchase-value]:not([data-value-ready])').forEach(host => {
      host.dataset.valueReady = 'true';
      const quantity = document.querySelector('product-info input[name="quantity"]');
      if (!quantity) return;
      function sync() { host.querySelectorAll('[data-dv-quantity]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dvQuantity === quantity.value))); }
      host.querySelectorAll('[data-dv-quantity]').forEach(button => button.addEventListener('click', () => {
        const amount = Number(button.dataset.dvQuantity);
        const minimum = Number(quantity.min || 1);
        const maximum = quantity.max ? Number(quantity.max) : Infinity;
        const step = Number(quantity.step || 1);
        const status = host.querySelector('[data-dv-quantity-status]');
        if (amount < minimum || amount > maximum || (amount - minimum) % step) { status.textContent = 'Þetta magn er ekki í boði. Veldu magn við kauphnappinn.'; return; }
        quantity.value = String(amount);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        status.textContent = `${amount} stk. valin. Smelltu á „Setja í körfu“ þegar þú ert tilbúin(n).`;
        sync();
      }));
      quantity.addEventListener('change', sync);
      sync();
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', () => { enhance(); refreshPrices(); });
  document.addEventListener('dv:complement-added', refreshPrices);
  root.addEventListener('pageshow', event => { if (event.persisted) refreshPrices(); });
  // Dawn's existing event bus covers successful adds, quantity changes and variant replacement.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshPrices);
    subscribe(PUB_SUB_EVENTS.variantChange, () => { enhance(); refreshPrices(); });
  }
})(typeof window === 'undefined' ? {} : window);
